import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserContext } from 'contexts/UserContext';
import { LoadingPage } from 'v3/pages/LoadingPage';
import { UpdatePasswordPage } from 'v3/pages/UpdatePassword';
import { mustChangePassword } from 'v3/utils/password';
import { isAuthenticated } from '../../services/auth';
import RouteElement from '../../router/RouteElement';

const PrivateRoute = ({ title, component: Component, path }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    isUserActive,
    isLoading,
    shouldUserChangePassword,
    lastPasswordUpdate,
    isUserBlocked,
    isCooperMail,
  } = useContext(UserContext);

  const authenticated = isAuthenticated();
  const shouldRedirectToChangePasswordModal = mustChangePassword({
    isCooperMail,
    isUserActive,
    isUserBlocked,
    authenticated,
    shouldUserChangePassword,
    lastPasswordUpdate,
  });

  useEffect(() => {
    if (isUserActive && authenticated && !isUserBlocked) {
      dispatch({ type: 'CURRENT_PATH', path });
    }
  }, [dispatch, path, isUserActive, authenticated, isUserBlocked]);

  if (isLoading) {
    return <LoadingPage isLoading={isLoading} />;
  }

  if (shouldRedirectToChangePasswordModal) {
    return <UpdatePasswordPage />;
  }

  if (isUserActive && authenticated && !isUserBlocked) {
    return <RouteElement component={Component} path={path} />;
  }
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  localStorage.removeItem('updatePushUserId');
  localStorage.removeItem('permissions');
  localStorage.removeItem('bot');
  localStorage.removeItem('issue_permission');

  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
};

export default PrivateRoute;
